import { useEffect, useState } from 'react';
import { ConnectionStatusStore } from '../stores/connection-status.store';

export function useConnectionStatus() {
  const [status, setStatus] = useState(() => ConnectionStatusStore.getState());

  useEffect(() => {
    const unsubscribe = ConnectionStatusStore.subscribe((snapshot) => {
      setStatus(snapshot);
    });
    return unsubscribe;
  }, []);

  return {
    isReachable: status.reachable,
    lostAt: status.reachable ? null : status.since,
    reconnecting: status.reconnecting,
    nextRetryAt: status.nextRetryAt,
  };
}
